import { io } from "socket.io-client";
import { defineStore } from "pinia";
import { sockBaseURL } from '@/config';
import { useSocket } from "./index";
import { getQueryString,filterMess } from '@/assets/js/index';
import { useScroll } from './scroll'
import { showLoadingToast, closeToast,showToast,showDialog} from 'vant'
import { showMess } from '@/components/common/toast'
export const useWork = defineStore("work", {
  state: () => ({
    reconnectAttempts: 0, // 重连计数器
    ing: false,
    status: 0,
    isReconnecting: false, // 重连状态锁
    socket: null,
    isConnect: false, // 是否连接
    timeoutObj: null,
    isUploading: false,
    contentType: 0,   // 0初始化 1 连接断开 2 连接错误 3 正在重连  4连接成功 5连接失败
    auth: {
      token: '',
      wxappId: getQueryString('wxappId')
    },
  }),
  actions: {
    setUpLoading(bool){
      this.isUploading=bool
    },
    setToken(token) {
      this.auth.token = token
    },
    putErr(tit) {
      console.log('---------------------------------------')
      console.log('---------------------------------------')
      console.log(tit)
      console.log('是否重连状态:', this.isReconnecting)
      console.log('socket状态:', this.socket.active)
      console.log('当前连接状态:', this.isConnect)
      console.log('---------------------------------------')
      console.log('---------------------------------------')
      console.log('---------------------------------------')
    },

    async init() {
      // 先清理旧连接
      if (this.socket) {
        await this.destroy()
      }
      const socket = io(sockBaseURL + "/user", {
        auth: {
          token: this.auth.token,
          wxappId: this.auth.wxappId
        },
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 3,
        reconnectionDelay: 3000,
        reconnectionDelayMax: 5000,
        timeout: 5000, // 连接超时时间
      })

      // 统一事件绑定
      this.bindSocketListeners(socket)
      this.socket = socket
      this.ing = true
    },
    async destroy() {
      if(this.isUploading) return
      console.log('连接销毁开始')
      if (this.socket) {
        // 清理所有事件监听
        this.socket.off('connect')
        this.socket.off('disconnect')
        this.socket.off('connect_error')
        this.socket.off('connect_timeout')
        this.socket.off('reconnect')
        this.socket.off('reconnect_failed')
        this.socket.off('message')
        this.socket.disconnect()
        this.socket = null
        clearInterval(this.timeoutObj)
        this.timeoutObj = null
      }

      this.putConnect(false)
      console.log('连接销毁完成')
    },
    bindSocketListeners(socket) {
      const handleConnect = () => {
        console.log('WebSocket已连接')
        this.reconnectAttempts = 0 // 重置重连计数器
        this.putConnect(true)
        this.heartCheck()
      }

      const handleDisconnect = async () => {
        if(this.isUploading) return
        this.putErr('断开连接')
        this.putConnect(false)
        await this.handleDisconnectLogic()
      }

      // 统一事件处理器
      socket.on('connect', handleConnect)
      socket.on('disconnect', handleDisconnect)
      socket.on('connect_error', this.handleConnectError)
      socket.on('connect_timeout', (timeout) => {
          this.putErr('监听连接超时事件')
          console.log('Connection Timeout:', timeout)
      })
      socket.on('reconnect', (attempt) => {
        console.log(`第${attempt}次重连成功`)
        this.putConnect(true)
      })
      socket.on('reconnect_failed', () => {
        console.log('重连最终失败')
        this.handleReconnectFailure()
      })
      socket.on('message', async (msg) => {
       
        const data = msg.data;
        console.log(data)
        const newMsg = {
          content: data.message,
          groupId: data.groupId,
          id:data.idStr,
          type: data.type,
          nickname: data.nickname,
          avatar: data.avatar,
          userType: data.userType,
          chatType: data.chatType,
          quotedMessageId: data.quotedMessageId,
          quotedMessage: data.quotedMessage
        };
        const routerName = location.pathname.indexOf('index') >= 0 ? 'index' : 'list'
        if (routerName === 'list') {
          await useSocket().addGroupAndChat(newMsg);
        } else {

            if (useSocket().group.id === data.groupId) {
              if(data.type===18){ //消息撤回
                const Index=useSocket().comments.findIndex(item=>item.id===data.message);
                useSocket().reCall(Index)
              }else{
                useSocket().addComment(newMsg);
                useScroll().toBottom();
              }
             
            }
            else {
              const groupList = await useSocket().groupList;
              if (groupList.length) {
                await useSocket().addGroupAndChat(newMsg);
              }
              showMess({
                name:data.nickname,
                content:filterMess(data.message,data.type),
                avatar:data.avatar,
              })
            }
          }
        });
    },
    handleReconnectFailure() {
      console.log('handleReconnectFailure: 处理最终重连失败')
      if (this.reconnectAttempts >= 3) {
        showToast('连接已断开，请检查网络后重新进入')
        showDialog({
          title: '连接已断开',
          message: '请尝试重新进入',
        }).then(async () => {
          window.location.reload();
        })
        // this.reconnectAttempts = 0 // 重置计数器
        // this.destroy(true) // 完全销毁连接
      }
    },
    async attemptAutoReconnect() {
      let resolved = false
      const onReconnect = () => {
        cleanup()
        console.log('自动重连成功')
        showToast('自动重连成功')
        resolved = true
      }

      const onReconnectFailed = () => {
        cleanup()
        console.log('自动重连失败')
        showToast('连接断开')
        this.retryWithBackoff()
      }

      // 添加超时检测
      const timeoutId = setTimeout(() => {
        if (!resolved) {
          cleanup()
          console.log('重连超时')
          this.retryWithBackoff()
        }
      }, 15000)

      const cleanup = () => {
        clearTimeout(timeoutId)
        this.socket.off('reconnect', onReconnect)
        this.socket.off('reconnect_failed', onReconnectFailed)
        this.isReconnecting = false
      }
      this.socket.once('reconnect', onReconnect)
      this.socket.once('reconnect_failed', onReconnectFailed)
    },
    async handleDisconnect() {
      this.putErr('断开连接')
      this.putConnect(false)
      await this.handleDisconnectLogic()
    },
    async handleDisconnectLogic() {
      if(this.isUploading) return
      console.log('连接断开处理开始')
      if (!this.isReconnecting) {
        this.isReconnecting = true
        try {
          const network = await this.checkNetwork()
          if (network.available) {
            await this.smartReconnect()
          } else{
            showDialog({
              title: '网络断开',
              message: '网络断开，是否重新连接？',
            }).then(async () => {
              window.location.reload();
            })
          }
        } finally {
          this.isReconnecting = false
        }
      }
    },
    async checkNetwork() {
      return new Promise((resolve) => {
        if (typeof navigator !== 'undefined') {
          const isOnline = navigator.onLine;
          if (!isOnline) {
            showToast('网络连接已断开');
            return resolve({ available: false });
          }
          const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
          if (!connection) {
            // 在小程序WebView中可能无法获取connection对象
            return resolve({ available: isOnline });
          }

          // 添加网络变化监听（原有代码基础上增强）
          const handleNetworkChange = () => {
            showToast(`网络状态变化：${navigator.onLine ? '已连接' : '已断开'}`);
          };
          
          window.addEventListener('online', handleNetworkChange);
          window.addEventListener('offline', handleNetworkChange);

          // 增加异常处理
          try {
            const networkTypeMap = {
              'wifi': 'wifi',
              'ethernet': 'wifi',
              'cellular': '移动网络',
              'none': '无网络'
            };
            console.log(`当前网络类型：${networkTypeMap[connection.type] || '未知网络'}`);
            resolve({ available: true });
          } catch (e) {
            console.error('网络检测异常:', e);
            resolve({ available: isOnline });
          }
        } else {
          resolve({ available: false });
        }
      });
    },
    async reconnectWithBackoff() {
      this.reconnectAttempts++
      const backoffDelay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 10000)
      await new Promise((resolve) => setTimeout(resolve, backoffDelay))
      await this.reconnect()
    },
    async smartReconnect() {
      if (this.reconnectAttempts >= 3) {
        console.log('已达最大重连次数')
        showToast('连接失败，请手动刷新')
        return
      }

      try {
        await this.reconnectWithBackoff()
      } catch (error) {
        console.log('智能重连失败:', error)
      }
    },
    async reconnect() {
      if (this.isConnect) return
      showLoadingToast({
        message: '正在重连...',
        duration: 0,
      })
      try {
        await this.destroy()
        await this.init()
      } catch (error) {
        console.log('重连失败:', error)
        throw error
      } finally {
        closeToast()
      }
    },
    
    start() {
      if (this.isConnect) {
        this.putErr('-----------心跳包----------')
        console.log('发送WebSocket心跳');
        const response = this.socket.emitWithAck("heartbeat", this.auth);
        useSocket().listenNums();
      
        // 如果需要处理响应结果
        response.then((ack) => {
          const code = ack.code;
          if (code !== 0) {
            showToast('连接异常，请尝试重新连接')
           // window.location.reload();
          }
        }).catch((error) => {
          console.error('Error:', error);
        });
      }
    },
    heartCheck() {
      clearInterval(this.timeoutObj);
      this.timeoutObj = setInterval(() => {
        this.start();
      }, 10000);
    },
    putConnect(bool) {
      this.isConnect = bool;
    },
  }
});